/**
 * Class My_Account
 * @constructor
 * @param {string} My_Account
 * My_Account pages
 * Created by: Fer Catalano 
 */

/* Constructor */
if (window.location.href.split('/')[3] == "my-account" ||
    window.location.href.split('/')[4] == "my-account" ||
    window.location.href.split('/')[3] == "wishlist" ||
    window.location.href.split('/')[4] == "wishlist") {
    var initIntervalMyAccount = window.setInterval(My_Account, 100);
}

function My_Account() {
    if (jQuery('.baketivity-my-account__dashboard__navigation').is(':visible') || jQuery('.baketivity-my-account__dashboard__breadcrumb-mobile').is(':visible')) {
        // init
        My_Account.prototype.init();
        // wishlist
        My_Account.prototype.wishlist();
        // clear interval
        clearInterval(initIntervalMyAccount);
    }
    // scroll event
    window.addEventListener('scroll', this.scroll);

}

My_Account.prototype.init = function () {
    let toggle = document.querySelector('.baketivity-my-account__dashboard__breadcrumb-mobile__toggler');
    if (toggle) {
        toggle.addEventListener('click', function () {
            document.querySelector('.baketivity-my-account__dashboard__shadow').classList.toggle('active');
            document.querySelector('.baketivity-my-account__dashboard__navigation').classList.toggle('active');
            document.querySelector('.baketivity-my-account__dashboard__breadcrumb-mobile__toggler').classList.toggle('active');
        });
    }
};

My_Account.prototype.scroll = function () {
    var header = document.getElementById("masthead");
    var navbarDashboard = document.querySelector(".baketivity-my-account__dashboard__breadcrumb-mobile");
    var navigationDashboard = document.querySelector(".baketivity-my-account__dashboard__navigation");
    if (!navigationDashboard) return;
    if (!navbarDashboard) return;

    var sticky = header.offsetTop;

    if (window.innerWidth < 768 && window.pageYOffset >= sticky) {
        navigationDashboard.classList.add("sticky");
        navbarDashboard.classList.add("sticky");
    } else {
        navigationDashboard.classList.remove("sticky");
        navbarDashboard.classList.remove("sticky");
    }
};

My_Account.prototype.wishlist = function () {
    if (window.location.href.split('/')[3] === "wishlist" || window.location.href.split('/')[4] === "wishlist") {
        document.querySelector('.woocommerce-MyAccount-navigation-link--dashboard').classList.remove('is-active');
        document.querySelector('.woocommerce-MyAccount-navigation-link--wishlist').classList.add('is-active');
    }

    const items = document.querySelectorAll('.wishlist_item');

    if (items) {
        items.forEach(function (item) {
            const remove = item.querySelector('.product-remove button');
            remove.addEventListener('click', function () {
                setTimeout(function () {
                    item.classList.add('removed');
                    //window.location.reload();
                }, 3000);
            });

        });
    }
};

new My_Account();